import React from "react";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  Chip,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import './styles.scss';

type ChipRadioGroupProps = {
  label: string;
  value: string;
  setValue: Function;
  options: String[];
  disabled?: boolean;
};

const ChipRadioGroup = (props: ChipRadioGroupProps) => {
  const { label, value, setValue, options, disabled } = props;
  const handleChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setValue(event.target.value);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        row
        aria-label="options"
        name="options"
        value={value}
        onChange={handleChange}
      >
        {options?.map((option) => {
          return (
            <FormControlLabel
              className="radio-group-label"
              value={option}
              disabled={disabled}
              control={<Radio className="radio-button" />} // Hide the default radio button
              label={
                <Chip
                  label={option}
                  variant={value === option ? "filled" : "outlined"}
                  color={value === option ? "primary" : "default"}
                  icon={value === option ? <DoneIcon /> : undefined}
                  size="small"
                  sx={{height: '32px'}}
                  className={
                    value === option ? 'chip' : 'chip chip-outlined'
                  }
                  disabled={disabled}
                />
              }
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export default ChipRadioGroup;
